import { IMenu } from '../models'
import CONFIG from '../../config'

const menuAdmin: IMenu[] = [
  {
    id: 1,
    name: 'Administrador de usuarios',
    icon: 'users',
    url: CONFIG.ROUTES.ADMIN.USERS.HOME,
    favoriteShow: false
  },
  {
    id: 201,
    name: 'Grupos familiares',
    icon: 'users',
    url: CONFIG.ROUTES.ADMIN.FAMILY.HOME,
    favoriteShow: false
  }
  /* {
    id: 3,
    name: 'Mis Exámenes',
    icon: 'mis-examenes',
    url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.HOME, // '/dashboard/mis-examenes/laboratorio',
    favoriteShow: false,
    children: [
      {
        id: 21,
        name: 'Laboratorio',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.LABORATORY
      },
      {
        id: 22,
        name: 'Imágenes y procedimientos',
        icon: '',
        url: CONFIG.ROUTES.DASHBOARD.EXAMSPROCEDURES.OTHEREXAMS
      }
    ]
  } */
];

export default menuAdmin;